import React from 'react';
import ResellerDetailPage from './ResellerDetailPage';
import { CRM_CONFIGS } from './resellerCrmShared';

// Lead Store detail — Reseller detail এর একই কোড, শুধু store config দিয়ে।
export default function StoreDetailPage() {
    return <ResellerDetailPage config={CRM_CONFIGS.store} />;
}
